import React, {useState} from "react";
import {StyledButton, Wrapper} from "./CodPaymentMethodSelectionLayer.styles";
import {useHistory} from "react-router-dom";
import {useStore} from "../../../../../hooks/useStore";
import {Spin} from "antd";
import {useCodPaymentMethodSelection} from "../../../../../hooks/useCodPaymentMethodSelection";
import {CodPaymentMethodSelectionForm} from "../codPaymentMethodSelectionForm/CodPaymentMethodSelectionForm";

export const CodPaymentMethodSelectionLayer = () => {
    const history = useHistory();
    const stores = useStore();

    const {
        subCompaniesResultsLoading,
        needToShowCodPaymentMethodSelection,
        canCodPaymentMethodSelectionSubcompanies,
        reloadSubCompaniesResults
    } = useCodPaymentMethodSelection({
        initialCall: !stores.meStore.hasCodPaymentMethodSelectionChecked,
        initialData: []
    });

    const toLogout = async () => {
        await stores.appStore.setLoading(true);
        await stores.meStore.logout();
        await history.push("/login");
        await stores.appStore.setLoading(false);
    };

    if (subCompaniesResultsLoading) {
        return (
            <Wrapper
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <Spin size="large" spinning={true} style={{padding: "50px", width: "auto"}} />

                <h1
                    style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        marginTop: "20px",
                        color: "#fff",
                        textAlign: "center"
                    }}
                >
                    Sözleşme durumu kontrol ediliyor...
                </h1>
            </Wrapper>
        );
    }

    if (!needToShowCodPaymentMethodSelection) {
        return <></>;
    }

    return (
        <>
            <Wrapper id="cod-payment-method-selection-layer">
                <div>
                    <CodPaymentMethodSelectionForm
                        paymentMethodsSelectionEnabledSubCompanies={
                            canCodPaymentMethodSelectionSubcompanies || []
                        }
                        recallFn={() => reloadSubCompaniesResults()}
                    />
                </div>

                <StyledButton size="xl" onClick={() => toLogout()}>
                    Çıkış Yap
                </StyledButton>
            </Wrapper>
        </>
    );
};
